import React, { useEffect } from 'react'
import './index.scss'

interface SnackbarProps {
  status: string
  message: string
  timeout: number
  onTimeout: () => void
}

export default function Snackbar({
  status,
  message,
  timeout,
  onTimeout,
}: SnackbarProps) {
  useEffect(() => {
    const timer = setTimeout(() => onTimeout(), timeout)
    return () => {
      clearTimeout(timer)
    }
  }, [])

  const getSnackbarClass = (): string => {
    const classes = {
      Success: 'success',
      Error: 'error',
      ErrorSuccess: 'error-success',
    }

    return `snackbar ${classes[status]}`
  }

  return (
    <div data-testid="snackbar" className={getSnackbarClass()}>
      {message}
    </div>
  )
}
